import React, { useState, useEffect } from 'react';

interface CountdownBabySectionProps {
  dueDate: Date;
  language: 'en' | 'mr';
}

interface TimeLeft {
  days: number;
  hours: number;
}

export const CountdownBabySection: React.FC<CountdownBabySectionProps> = ({ dueDate, language }) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ days: 0, hours: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const eventTime = dueDate.getTime();
      const difference = eventTime - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [dueDate]);

  return (
    <section className="relative py-24 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-pink-500 mb-16">
          {language === 'mr' ? '⏳ बाकी दिवस' : '⏳ Days Until Arrival'}
        </h2>

        <div className="grid grid-cols-2 gap-8 max-w-md mx-auto">
          <div className="text-center p-8 bg-white rounded-3xl shadow-lg border-4 border-yellow-400">
            <div className="text-6xl font-black text-yellow-500 animate-pulse">
              {String(timeLeft.days).padStart(2, '0')}
            </div>
            <p className="text-sm font-bold text-gray-600 uppercase mt-2">
              {language === 'mr' ? 'दिवस' : 'Days'}
            </p>
          </div>

          <div className="text-center p-8 bg-white rounded-3xl shadow-lg border-4 border-pink-400">
            <div className="text-6xl font-black text-pink-500 animate-pulse">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <p className="text-sm font-bold text-gray-600 uppercase mt-2">
              {language === 'mr' ? 'तास' : 'Hours'}
            </p>
          </div>
        </div>

        <p className="text-center mt-12 text-gray-600 text-lg font-semibold">
          ✨ {language === 'mr' ? 'नवजातकाचा आगमन' : "Baby's arrival is getting closer!"}
        </p>
      </div>
    </section>
  );
};
